<form autocomplete="off" class="p-0" novalidate [formGroup]="contactDetailsForm">
    <div class="col-lg-12 col-md-12">
        <div class="mt-3">
            <div class="mb-2">
                <h3 class="main-content-label mb-2"><b>
                        <img alt="Logo" width="20vh" src="../../assets/images/business-card.png"
                            class="mh-45px mrl mt-1 pb-2">
                        Contact Details</b></h3>
            </div>
            <div *ngIf="ContactShow" class="row clearfix">
                <div class="col-sm-3" *ngIf="contactDetailsFormArray['StuNationality'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{contactDetailsFormArray['StuNationality'][0]['FormDisplayName']}}
                                    <span *ngIf="contactDetailsFormArray['StuNationality'][0]['FormRequired']">*</span>
                                </mat-label>
                                <mat-select #select11 placeholder="" class="colorblack"
                                    formControlName="StuNationality">
                                    <mat-select-filter *ngIf="select11.focused" [placeholder]="'Filter'"
                                        [displayMember]="'CdDesc'" [array]="nationalityList"
                                        (filteredReturn)="filteredNationalityList =$event">
                                    </mat-select-filter>
                                    <mat-option *ngFor="let item of filteredNationalityList" [value]="item.CdCode" (click)="nationalitySelection(item)">
                                        {{item.CdDesc}}
                                    </mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuNationality'].touched && contactDetailsForm.controls['StuNationality'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="contactDetailsFormArray['StuDomicile'][0]['FormVisible'] && isIndian">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{contactDetailsFormArray['StuDomicile'][0]['FormDisplayName']}}
                                    <span *ngIf="contactDetailsFormArray['StuDomicile'][0]['FormRequired']">*</span>
                                </mat-label>
                                <mat-select #select12 placeholder="" class="colorblack" formControlName="StuDomicile">
                                    <mat-select-filter *ngIf="select12.focused" [placeholder]="'Filter'"
                                        [displayMember]="'CdDesc'" [array]="domicileList"
                                        (filteredReturn)="filteredDomicileList =$event">
                                    </mat-select-filter>
                                    <mat-option *ngFor="let item of filteredDomicileList" [value]="item.CdCode">
                                        {{item.CdDesc}}
                                    </mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuDomicile'].touched && contactDetailsForm.controls['StuDomicile'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="contactDetailsFormArray['StuRegion'][0]['FormVisible'] && isIndian">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{contactDetailsFormArray['StuRegion'][0]['FormDisplayName']}}
                                    <span *ngIf="contactDetailsFormArray['StuRegion'][0]['FormRequired']">*</span>
                                </mat-label>

                                <mat-select #select13 placeholder="" class="colorblack" formControlName="StuRegion">
                                    <mat-select-filter *ngIf="select13.focused" [placeholder]="'Filter'"
                                        [displayMember]="'CdDesc'" [array]="regionList"
                                        (filteredReturn)="filteredRegionList =$event">
                                    </mat-select-filter>
                                    <mat-option *ngFor="let item of filteredRegionList" [value]="item.CdCode">
                                        {{item.CdDesc}}
                                    </mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuRegion'].touched && contactDetailsForm.controls['StuRegion'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="contactDetailsFormArray['StuMobNo'][0]['FormVisible'] && isIndian">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{contactDetailsFormArray['StuMobNo'][0]['FormDisplayName']}}
                                    <span *ngIf="contactDetailsFormArray['StuMobNo'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input matInput formControlName="StuMobNo" placeholder="Mobile" maxlength="10">
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuMobNo'].touched && contactDetailsForm.controls['StuMobNo'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuMobNo'].touched && contactDetailsForm.controls['StuMobNo'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="contactDetailsFormArray['StuLandNo'][0]['FormVisible'] && isIndian">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{contactDetailsFormArray['StuLandNo'][0]['FormDisplayName']}}
                                    <span *ngIf="contactDetailsFormArray['StuLandNo'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input matInput formControlName="StuLandNo" placeholder="Landline" maxlength="12">
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuLandNo'].touched && contactDetailsForm.controls['StuLandNo'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuLandNo'].touched && contactDetailsForm.controls['StuLandNo'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-3 " *ngIf="contactDetailsFormArray['StuEmailId'][0]['FormVisible'] && isIndian">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{contactDetailsFormArray['StuEmailId'][0]['FormDisplayName']}}
                                    <span *ngIf="contactDetailsFormArray['StuEmailId'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input matInput formControlName="StuEmailId" placeholder="Email">
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuEmailId'].touched && contactDetailsForm.controls['StuEmailId'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuEmailId'].touched && contactDetailsForm.controls['StuEmailId'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <!-- <div class="col-sm-6 "></div> -->
                <div class="col-sm-3" *ngIf="contactDetailsFormArray['StuAddrC'][0]['FormVisible'] && isIndian">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{contactDetailsFormArray['StuAddrC'][0]['FormDisplayName']}}
                                    <span *ngIf="contactDetailsFormArray['StuAddrC'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input matInput formControlName="StuAddrC" placeholder="Address" maxlength="150">
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuAddrC'].touched && contactDetailsForm.controls['StuAddrC'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuAddrC'].touched && contactDetailsForm.controls['StuAddrC'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
               
                <div class="col-sm-3" *ngIf="contactDetailsFormArray['StuAddr2C'][0]['FormVisible'] && isIndian">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{contactDetailsFormArray['StuAddr2C'][0]['FormDisplayName']}}
                                    <span *ngIf="contactDetailsFormArray['StuAddr2C'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input matInput formControlName="StuAddr2C" placeholder="Address" maxlength="150">
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuAddr2C'].touched && contactDetailsForm.controls['StuAddr2C'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuAddr2C'].touched && contactDetailsForm.controls['StuAddr2C'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="contactDetailsFormArray['StuAddr3C'][0]['FormVisible'] && isIndian">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{contactDetailsFormArray['StuAddr3C'][0]['FormDisplayName']}}
                                    <span *ngIf="contactDetailsFormArray['StuAddr3C'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input matInput formControlName="StuAddr3C" placeholder="Address" maxlength="150">
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuAddr3C'].touched && contactDetailsForm.controls['StuAddr3C'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuAddr3C'].touched && contactDetailsForm.controls['StuAddr3C'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="contactDetailsFormArray['StuAddr4C'][0]['FormVisible'] && isIndian">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{contactDetailsFormArray['StuAddr4C'][0]['FormDisplayName']}}
                                    <span *ngIf="contactDetailsFormArray['StuAddr4C'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input matInput formControlName="StuAddr4C" placeholder="Address" maxlength="150">
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuAddr4C'].touched && contactDetailsForm.controls['StuAddr4C'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuAddr4C'].touched && contactDetailsForm.controls['StuAddr4C'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="contactDetailsFormArray['StuCountryC'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{contactDetailsFormArray['StuCountryC'][0]['FormDisplayName']}}
                                    <span *ngIf="contactDetailsFormArray['StuCountryC'][0]['FormRequired']">*</span>
                                </mat-label>
                                <mat-select formControlName="StuCountryC" #select1 placeholder="State"
                                    class="colorblack" #select14>
                                    <mat-select-filter *ngIf="select14.focused" [placeholder]="'Filter'"
                                        [displayMember]="'CountryName'" [array]="CCountryCodeList"
                                        (filteredReturn)="CfilteredListCountryCode =$event"></mat-select-filter>
                                    <mat-option *ngFor="let item of CfilteredListCountryCode" [value]="item.CountryCode"
                                        (click)="fetchStateC(item.CountryCode)">
                                        {{item.CountryName}}
                                    </mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuCountryC'].touched && contactDetailsForm.controls['StuCountryC'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="contactDetailsFormArray['StuStateC'][0]['FormVisible'] && isIndian">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{contactDetailsFormArray['StuStateC'][0]['FormDisplayName']}}
                                    <span *ngIf="contactDetailsFormArray['StuStateC'][0]['FormRequired']">*</span>
                                </mat-label>
                                <mat-select formControlName="StuStateC" placeholder="State" class="colorblack"
                                    #select15>
                                    <mat-select-filter *ngIf="select15.focused" [placeholder]="'Filter'"
                                        [displayMember]="'StateName'" [array]="StateCodeListC"
                                        (filteredReturn)="filteredListStateC =$event"></mat-select-filter>
                                    <mat-option *ngFor="let item of filteredListStateC" [value]="item.StateCode"
                                        (click)="fetchDistrictC(item.StateCode)">
                                        {{item.StateName}}
                                    </mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuStateC'].touched && contactDetailsForm.controls['StuStateC'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="contactDetailsFormArray['StuDistrictC'][0]['FormVisible'] && isIndian">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{contactDetailsFormArray['StuDistrictC'][0]['FormDisplayName']}}
                                    <span *ngIf="contactDetailsFormArray['StuDistrictC'][0]['FormRequired']">*</span>
                                </mat-label>
                                <mat-select placeholder="District" class="colorblack" formControlName="StuDistrictC"
                                    #select16>
                                    <mat-select-filter *ngIf="select16.focused" [placeholder]="'Filter'"
                                        [displayMember]="'DsName'" [array]="districtCodeListC"
                                        (filteredReturn)="filteredListDistrictC =$event"></mat-select-filter>
                                    <mat-option *ngFor="let item of filteredListDistrictC" [value]="item.DsCode"
                                        (click)="getTehasilDataC(item.DsCode)">
                                        {{item.DsName}}
                                    </mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuDistrictC'].touched && contactDetailsForm.controls['StuDistrictC'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="contactDetailsFormArray['StuTehsilC'][0]['FormVisible'] && isIndian">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{contactDetailsFormArray['StuTehsilC'][0]['FormDisplayName']}}
                                    <span *ngIf="contactDetailsFormArray['StuTehsilC'][0]['FormRequired']">*</span>
                                </mat-label>
                                <!-- <mat-select #select104 class="colorblack"
                                        formControlName="StuTehsilC">
                                        <mat-option>Select</mat-option>
                                        <mat-option value="1">Akola</mat-option>
                                        <mat-option value="2">Rahuri</mat-option>
                                        <mat-option value="3">Nagar</mat-option>
                                        <mat-option value="4">Karjat</mat-option>
                                    </mat-select> -->
                                <mat-select formControlName="StuTehsilC" #select119 placeholder="District"
                                    class="colorblack">
                                    <mat-select-filter *ngIf="select119.focused" [placeholder]="'Filter'"
                                        [displayMember]="'TsName'" [array]="tehasilCList"
                                        (filteredReturn)="filteredtehasilCList =$event"></mat-select-filter>
                                    <mat-option *ngFor="let item of filteredtehasilCList" [value]="item.TsCode">
                                        {{item.TsName}}
                                    </mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuTehsilC'].touched && contactDetailsForm.controls['StuTehsilC'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="contactDetailsFormArray['StuCityC'][0]['FormVisible'] && isIndian">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{contactDetailsFormArray['StuCityC'][0]['FormDisplayName']}}
                                    <span *ngIf="contactDetailsFormArray['StuCityC'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input matInput placeholder="City / Village / Area / Ward" maxlength="150"
                                    formControlName="StuCityC">
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuCityC'].touched && contactDetailsForm.controls['StuCityC'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuCityC'].touched && contactDetailsForm.controls['StuCityC'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="contactDetailsFormArray['StuPinC'][0]['FormVisible'] && isIndian">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{contactDetailsFormArray['StuPinC'][0]['FormDisplayName']}}
                                    <span *ngIf="contactDetailsFormArray['StuPinC'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input matInput placeholder="Pincode" minlength="6" maxlength="6"
                                    formControlName="StuPinC">
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuPinC'].touched && contactDetailsForm.controls['StuPinC'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuPinC'].touched && contactDetailsForm.controls['StuPinC'].errors?.pattern">
                                    Invalid
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuPinC'].touched && contactDetailsForm.controls['StuPinC'].errors?.minlength">
                                    Enter 6 digit pincode.
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-12">
                    <div class="col-sm-2 mt-3" *ngIf="contactDetailsFormArray['StuSameAddr'][0]['FormVisible'] && isIndian">
                        <div class="form-group">
                            <mat-checkbox class="example-full-width" formControlName="StuSameAddr"
                                onkeydown="return (event.keyCode!=13);" (change)="copyAddress($event)">
                                {{contactDetailsFormArray['StuSameAddr'][0]['FormDisplayName']}}
                            </mat-checkbox>
                        </div>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="contactDetailsFormArray['StuAddrP'][0]['FormVisible'] && isIndian">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{contactDetailsFormArray['StuAddrP'][0]['FormDisplayName']}}
                                    <span *ngIf="contactDetailsFormArray['StuAddrP'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="isreadonly" maxlength="150" formControlName="StuAddrP" matInput
                                    placeholder="Address">
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuAddrP'].touched && contactDetailsForm.controls['StuAddrP'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuAddrP'].touched && contactDetailsForm.controls['StuAddrP'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="contactDetailsFormArray['StuAddr2P'][0]['FormVisible'] && isIndian">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{contactDetailsFormArray['StuAddr2P'][0]['FormDisplayName']}}
                                    <span *ngIf="contactDetailsFormArray['StuAddr2P'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="isreadonly" maxlength="150" formControlName="StuAddr2P" matInput
                                    placeholder="Address">
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuAddr2P'].touched && contactDetailsForm.controls['StuAddr2P'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuAddr2P'].touched && contactDetailsForm.controls['StuAddr2P'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="contactDetailsFormArray['StuAddr3P'][0]['FormVisible'] && isIndian">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{contactDetailsFormArray['StuAddr3P'][0]['FormDisplayName']}}
                                    <span *ngIf="contactDetailsFormArray['StuAddr3P'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="isreadonly" maxlength="150" formControlName="StuAddr3P" matInput
                                    placeholder="Address">
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuAddr3P'].touched && contactDetailsForm.controls['StuAddr3P'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuAddr3P'].touched && contactDetailsForm.controls['StuAddr3P'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="contactDetailsFormArray['StuAddr4P'][0]['FormVisible'] && isIndian">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{contactDetailsFormArray['StuAddr4P'][0]['FormDisplayName']}}
                                    <span *ngIf="contactDetailsFormArray['StuAddr4P'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="isreadonly" maxlength="150" formControlName="StuAddr4P" matInput
                                    placeholder="Address">
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuAddr4P'].touched && contactDetailsForm.controls['StuAddr4P'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuAddr4P'].touched && contactDetailsForm.controls['StuAddr4P'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="contactDetailsFormArray['StuCountryP'][0]['FormVisible'] && isIndian">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{contactDetailsFormArray['StuCountryP'][0]['FormDisplayName']}}
                                    <span *ngIf="contactDetailsFormArray['StuCountryP'][0]['FormRequired']">*</span>
                                </mat-label>
                                <mat-select [disabled]="isreadonly" formControlName="StuCountryP" placeholder="State"
                                    class="colorblack" #select17>
                                    <mat-select-filter *ngIf="select17.focused" [placeholder]="'Filter'"
                                        [displayMember]="'CountryName'" [array]="PCountryCodeList"
                                        (filteredReturn)="filteredListPCountryCode =$event"></mat-select-filter>
                                    <mat-option *ngFor="let item of filteredListPCountryCode" [value]="item.CountryCode"
                                        (click)="fetchStateP(item.CountryCode)">
                                        {{item.CountryName}}
                                    </mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuCountryP'].touched && contactDetailsForm.controls['StuCountryP'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="contactDetailsFormArray['StuStateP'][0]['FormVisible'] && isIndian">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{contactDetailsFormArray['StuStateP'][0]['FormDisplayName']}}
                                    <span *ngIf="contactDetailsFormArray['StuStateP'][0]['FormRequired']">*</span>
                                </mat-label>
                                <mat-select [disabled]="isreadonly" formControlName="StuStateP" #select18
                                    placeholder="State" class="colorblack">
                                    <mat-select-filter *ngIf="select18.focused" [placeholder]="'Filter'"
                                        [displayMember]="'StateName'" [array]="StateCodeListP"
                                        (filteredReturn)="filteredListStateP =$event"></mat-select-filter>
                                    <mat-option *ngFor="let item of filteredListStateP" [value]="item.StateCode"
                                        (click)="fetchDistrictP(item.StateCode)">
                                        {{item.StateName}}
                                    </mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuStateP'].touched && contactDetailsForm.controls['StuStateP'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="contactDetailsFormArray['StuDistrictP'][0]['FormVisible'] && isIndian">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{contactDetailsFormArray['StuDistrictP'][0]['FormDisplayName']}}
                                    <span *ngIf="contactDetailsFormArray['StuDistrictP'][0]['FormRequired']">*</span>
                                </mat-label>
                                <mat-select [disabled]="isreadonly" formControlName="StuDistrictP" #select19
                                    placeholder="District" class="colorblack">
                                    <mat-select-filter *ngIf="select19.focused" [placeholder]="'Filter'"
                                        [displayMember]="'DsName'" [array]="districtCodeListP"
                                        (filteredReturn)="filteredListDistrictP =$event"></mat-select-filter>
                                    <mat-option *ngFor="let item of filteredListDistrictP" [value]="item.DsCode"
                                        (click)="getTehasilDataP(item.DsCode)">
                                        {{item.DsName}}
                                    </mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuDistrictP'].touched && contactDetailsForm.controls['StuDistrictP'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="contactDetailsFormArray['StuTehsilP'][0]['FormVisible'] && isIndian">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{contactDetailsFormArray['StuTehsilP'][0]['FormDisplayName']}}
                                    <span *ngIf="contactDetailsFormArray['StuTehsilP'][0]['FormRequired']">*</span>
                                </mat-label>
                                <!-- <mat-select [disabled]="isreadonly" formControlName="StuTehsilP" #select104 placeholder="Nationality"
                                        class="colorblack">
                                        <mat-option>Select</mat-option>
                                        <mat-option value="1">Akola</mat-option>
                                        <mat-option value="2">Rahuri</mat-option>
                                        <mat-option value="3">Nagar</mat-option>
                                        <mat-option value="4">Karjat</mat-option>
                                    </mat-select> -->
                                <mat-select [disabled]="isreadonly" formControlName="StuTehsilP" #select119
                                    placeholder="District" class="colorblack">
                                    <mat-select-filter *ngIf="select119.focused" [placeholder]="'Filter'"
                                        [displayMember]="'TsName'" [array]="tehasilPList"
                                        (filteredReturn)="filteredtehasilPList =$event"></mat-select-filter>
                                    <mat-option *ngFor="let item of filteredtehasilPList" [value]="item.TsCode">
                                        {{item.TsName}}
                                    </mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuTehsilP'].touched && contactDetailsForm.controls['StuTehsilP'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="contactDetailsFormArray['StuCityP'][0]['FormVisible'] && isIndian">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{contactDetailsFormArray['StuCityP'][0]['FormDisplayName']}}
                                    <span *ngIf="contactDetailsFormArray['StuCityP'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input formControlName="StuCityP" matInput [readonly]="isreadonly" maxlength="150"
                                    placeholder="City / Village / Area / Ward">
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuCityP'].touched && contactDetailsForm.controls['StuCityP'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuCityP'].touched && contactDetailsForm.controls['StuCityP'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="contactDetailsFormArray['StuPinP'][0]['FormVisible'] && isIndian">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{contactDetailsFormArray['StuPinP'][0]['FormDisplayName']}}
                                    <span *ngIf="contactDetailsFormArray['StuPinP'][0]['FormRequired']">*</span>

                                </mat-label>
                                <input matInput placeholder="Pincode" minlength="6" maxlength="6"
                                    [readonly]="isreadonly" formControlName="StuPinP">
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuPinP'].touched && contactDetailsForm.controls['StuPinP'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuPinP'].touched && contactDetailsForm.controls['StuPinP'].errors?.pattern">
                                    Invalid
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="contactDetailsForm.controls['StuPinP'].touched && contactDetailsForm.controls['StuPinP'].errors?.minlength">
                                    Enter 6 digit pincode.
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                                <h6 *ngIf="updateButton" class="mb-3 mt-3 redCol" ><b>
                        * Note: If You Updated Nationality, Please Resubmit The Last Document Upload Tab.</b></h6>
                <div class="row mb-2 prpl">
                    <div class="col-sm-12">
                        <button type="button" *ngIf="submitButton" 
                            class="btn btn-primary btn-icon-text floatright fr sz mt-1"
                            (click)="submitContactDetails()">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/images/save.gif" style="margin-right: 5px;">
                                Save
                            </span>
                        </button>
                        <button type="button" *ngIf="updateButton" [disabled]="disabled" 
                            (click)="UpdateContactDetails()"
                            class="btn btn-primary btn-icon-text floatright fr sz mt-1">
                            <span style="display: contents; align-items: center;">
                                <img width="20%" src="../../assets/images/edit.gif" style="margin-right: 5px;">
                                Update
                            </span>
                        </button>
                        <button type="button" (click)="back()"
                            class="btn btn-primary btn-icon-text floatright fr  mt-1">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/images/turn-left.gif" style="margin-right: 5px;">
                                Back
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>